export async function waitForExportAssets(root: HTMLElement, timeoutMs = 5_000): Promise<string[]> {
  const warnings: string[] = [];
  const timeout = new Promise<'timeout'>((resolve) =>
    setTimeout(() => resolve('timeout'), timeoutMs),
  );
  if (document.fonts?.ready) {
    if (
      (await Promise.race([document.fonts.ready.then(() => 'ready' as const), timeout])) ===
      'timeout'
    ) {
      warnings.push('Fonts did not finish loading; system font fallback may be used.');
    }
  }
  const images = [...root.querySelectorAll('img')];
  const results = await Promise.all(
    images.map(async (image) => {
      if (image.complete && image.naturalWidth > 0) return true;
      return Promise.race([
        new Promise<boolean>((resolve) => {
          image.addEventListener('load', () => resolve(true), { once: true });
          image.addEventListener('error', () => resolve(false), { once: true });
        }),
        timeout.then(() => false),
      ]);
    }),
  );
  if (results.some((ready) => !ready))
    warnings.push('One or more images were omitted from export.');
  return warnings;
}
